import developmentApiconfig from "./apiconfig-development.json";
import productionApiconfig from "./apiconfig-production.json";

const config =
  process.env.NODE_ENV === "development"
    ? developmentApiconfig
    : productionApiconfig;

export default config;
